interface MetricCardProps {
  /** Display title for the metric */
  title: string;
  /** Numeric value to display */
  value: number;
  /** Material Symbols icon name */
  icon: string;
  /** Background color class for the icon container (Tailwind) */
  iconBgColor: string;
  /** Text color class for the icon (Tailwind) */
  iconColor: string;
  /** Whether the metric is loading */
  isLoading?: boolean;
}

/**
 * MetricCard component - Displays a single metric with icon
 *
 * Used in the MetricsDashboard to show document counts by status.
 * Supports loading state with skeleton animation.
 */
export function MetricCard({
  title,
  value,
  icon,
  iconBgColor,
  iconColor,
  isLoading = false,
}: MetricCardProps) {
  return (
    <div
      className={`
        bg-white dark:bg-[#192233]/50 
        p-4 rounded-xl 
        border border-gray-200 dark:border-[#232f48] 
        flex items-center gap-4
      `}
    >
      {/* Icon container */}
      <div className={`p-2 rounded-lg ${iconBgColor}`}>
        <span className={`material-symbols-outlined ${iconColor}`}>{icon}</span>
      </div>

      {/* Content */}
      <div>
        <p className="text-xs text-gray-500 dark:text-[#92a4c9] uppercase font-bold tracking-wider">
          {title}
        </p>
        {isLoading ? (
          <div className="h-8 w-16 bg-gray-200 dark:bg-gray-700 rounded animate-pulse mt-1" />
        ) : (
          <p className="text-2xl font-black text-black dark:text-white">{value.toLocaleString()}</p>
        )}
      </div>
    </div>
  );
}
